import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import LogRocket from "logrocket";
import ReactPixel from "react-facebook-pixel";
import "./styles.scss";
import ReactGA from "react-ga4";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// ReactGA.initialize("G-66SSXJQTBF");

if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("G-9HQQ8RM696");
} else {
  ReactGA.initialize("G-BC3TM7EPB5");
}
const pixelId = "526408417088908"; 
ReactPixel.init(pixelId);
ReactPixel.pageView(); // For tracking page views
LogRocket.init("gbijfc/podcast-fellowship");
// Removed setupLogRocketReact: logrocket-react@6 is incompatible with React 18
// and crashes development builds with "jsxDEV is not a function", which
// white-screens the whole app (dev site incident, July 2026). Base LogRocket
// is kept. Re-add the React plugin only after upgrading logrocket-react.
// }

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
